import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-business-location.scss'

export default register(`business-location-section`, {
    onLoad() {
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload() {
    },
})